import { combineReducers } from 'redux';
import {
  fetchFormAction,
  fetchFormSuccessAction,
  toggleTaskAction,
  updateDataAction,
} from '../actions/form';
import { createReducer } from 'redux-create-reducer';
import dotProp from 'dot-prop-immutable';

const isFetching = createReducer(false, {
  [fetchFormAction]: (state, action) => {
    return true;
  },
  [fetchFormSuccessAction]: (state, action) => {
    return false;
  },
});

const form = createReducer(
  {},
  {
    [fetchFormSuccessAction]: (state, action) => {
      const diags = action.payload.diags.reduce((map, obj) => {
        map[obj.site_id] = obj;
        return map;
      }, {});
      return {
        ...state,
        diags,
      };
    },
    [updateDataAction]: (state, action) => {
      const { siteId, task, propName, propValue } = action.payload;
      const stateWithProp = dotProp.set(
        state,
        `diags.${siteId}.${task}.${propName}`,
        propValue
      );
      return dotProp.merge(stateWithProp, `diags.${siteId}.${task}`, {
        activated: true,
      });
    },
    [toggleTaskAction]: (state, action) => {
      const { siteId, task } = action.payload;
      return dotProp.toggle(state, `diags.${siteId}.${task}.activated`);
    },
  }
);

const formReducer = combineReducers({
  isFetching,
  form,
});

export default formReducer;

export const getSiteDiagnosis = state => siteId => {
  if (state.form.form && state.form.form.diags) {
    return state.form.form.diags[siteId] || {};
  } else {
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/reducers/form.js